module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-1-orange-98d2827a733de4468c68bf0166d93643.svg";